var r={defaultDark:"#000000",premiumPrimary:"#136BFB",premiumSecondary:"#2213fb",premiumPrimaryDisabled:"#136BFB40",propertiesDivider:"#BDBDBD",masterSpecPrimary:"#F78909",noPropertyLabel:"#5E5F61"};export default r;
